const cookieName = 'footballco';

export default cookieName;
